// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__3R7O5"};